/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_ExecutedInputs */

const en_vendor_return_status_executed = /** @type {(inputs: Vendor_Return_Status_ExecutedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Vendor_Return_Status_ExecutedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_executed = /** @type {((inputs?: Vendor_Return_Status_ExecutedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_ExecutedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_executed(inputs)
});